import { allocation, Allocation, Identifiable, Task } from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";
import { LinkedAllocation } from "../linkers/types";
import { mapError } from "../utils/mapError";

type Response = {
  allocatedHours: null | number;
  estimatedAt: number;
  percentComplete: number;
  resource: null;
  resourceUuid: string;
  task: null;
  taskUuid: string;
  uuid: string;
}[];

function saveAllocations(httpClient: HttpClient) {
  return (task: Identifiable<Task>, allocations: Allocation[]) =>
    httpClient
      .sendHttpRequest<Response>({
        endpoint: "/allocations/batch",
        method: HttpMethods.POST,
        data: allocations.map(({ resource, task: t, ...allocation }) => ({
          ...allocation,
          taskUuid: task.uuid,
          resourceUuid: resource.uuid,
        })),
      })
      .then(
        (savedAllocations) =>
          savedAllocations.map((alloc) => {
            const foundAll = allocations.find(
              ({ resource }) => resource.uuid === alloc.resourceUuid,
            );

            return {
              ...allocation,
              ...alloc,
              task,
              resource: foundAll ? foundAll.resource : allocation.resource,
            };
          }) as Identifiable<Allocation>[],
      )
      .catch((e) =>
        Promise.reject(
          mapError(e, {
            duplicateAllocation: "duplicateAllocation",
          }),
        ),
      );
}

export { saveAllocations };
